export default "/_next/static/images/img6-401a8bdb75d159afd58adb3a1082392c.png";